import React, { Component } from 'react';
import LongText from '../Utils/LongText.js';
import ModalImage from '../Utils/ModalImage.js';

class Description extends Component {
    render() {
        const { activeButton } = this.props;

        let date = new Date();
        let full_date = date.toLocaleDateString().replace(/\//g, "_");
        let new_workshop_file_name = "AwakeningIntuitionActivityRyanHenaoInstructorsCopy_" + full_date + ".pdf"

        let file_path = "/documents/";
        let workshop_file = "AwakeningIntuitionActivityRyanHenaoInstructorsCopy.pdf";
        let workshop_file_path = file_path + workshop_file;

        let workshop_file_image = "AwakeningIntuitionActivityRyanHenaoInstructorsCopyThumbnail.jpg";
        let workshop_download_image = file_path + workshop_file_image;

        let image_path = "/images/art/workshops/";
        let workshop_image = "workshop_main_image.jpg";
        let workshop_image_path = image_path + workshop_image;

        let workshop_title = <h2>Awakening Intuition Through Artistic Collage</h2>

        let workshop_description = <p>The participants spent time looking through
            magazines, used art books, and other picture books I gathered, cutting out
            images that resonated with them in some way. They were instructed to
            maintain a mindful and inquisitive nature throughout the process as they
            observed which images they chose. Some things to consider were, how each
            image made them feel, what associations arose, and which senses they
            observed them through. After collaging participants were invited to see what
            meaning their art work revealed to them. Similar to Jung's sand-play, the
            imaginative process of collaging various images together on paper helps to
            bring to the surface unconscious feelings, beliefs, goals and motivations;
            the context of a playful, allows for all of this to be done in a safe and
            fun manner.</p>

        return (
            <div className="unset-all">
                {activeButton === 'description' && (
                    <div className="workshop_description">
                        <div className="workshop_description_wrapper">
                            <LongText maxLength={1} byParagraphs>
                                <p>
                                    I designed and carried out a workshop that's
                                    geared towards exploring creativity,
                                    intuition, and imaginal play as a means for
                                    therapeutic self understanding.
                                </p>
                                <p>
                                    The goal was to create an environment where participants could
                                    get in touch with their own creative and intuitive thinking. I
                                    designed a series of questions and explorations, to invite the
                                    participants to dive deeper into their inner selves. We worked
                                    with artistic collaging allowing the images we bring together to
                                    inform our own personal stories, learning from what we find
                                    ourselves making. I’ve posted art from participants of various
                                    sessions, as well as how the experience went and lessons
                                    learned.
                                </p>
                                <p>
                                    One friend commented how surprised she was at he meaning she
                                    found in her own piece. She found the exercise tremendously
                                    helpful in that it made the elusive concept of intuition
                                    concrete, seeing how she had chosen images relating to herself
                                    and how her art told a meaningful story about what she values in
                                    herself. She also appreciated how, I emphasized the
                                    non-judgemental nature of our process. There were no right or
                                    wrong answers only things to be curious about and ponder.
                                </p>
                            </LongText>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default Description;